import type { AccessibleLocation, GrantedClientLocation } from '../../../types/access'

/** Context passed when creating a job on behalf of a client company through a federated relationship */
export type DelegatedJobContext = {
  nonce: number
  relationshipId: string
  companyOrgId: string
  companyOrgName: string
  agencyOrgId: string
  agencyOrgName: string
  /** Pre-selected granted location id (optional) */
  locationId?: string | null
  locationTenantId?: string | null
  locationName?: string | null
  /** Full granted location list from the relationship entry */
  grantedLocations?: GrantedClientLocation[]
}

export type LocationJobDraft = {
  nonce: number
  locationId: string
  ownerOrgId?: string | null
  source: 'locations' | 'mapper'
}

export const getAccessibleLocationOwnerOrgId = (location: Pick<AccessibleLocation, 'ownerOrgId' | 'owner_org_id' | 'companyOrgId' | 'company_org_id' | 'metadata'>) => (
  location.ownerOrgId
  || location.owner_org_id
  || location.companyOrgId
  || location.company_org_id
  || String(location.metadata?.ownerOrgId || location.metadata?.owner_org_id || location.metadata?.companyOrgId || location.metadata?.company_org_id || '')
  || ''
)
